<template>
    <div class="text-center">
      <v-dialog dark v-model="dialog" width="500"> 

        <v-card>
        <v-card-title class="text-h5" style="background-color: #161d30;">
            <p class="text-center ma-0"> Agregar Comprobante  </p>
        </v-card-title>
        <!-- // archivo, numero compr, fecha, monto -->

        <v-card-text style="background-color: #283045;">
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="row justify-center mt-4">
                    <div class="col-xs-12 col-sm-6">
                        <v-text-field v-model.number="valor" type="number" step="0.01" :counter="10" label="Monto" required></v-text-field>
                    </div> 
                    <div class="col-xs-12 col-sm-6">
                        <v-text-field v-model.trim="comprobante" type="text" step="0.01" :counter="10" label="Nro. comprobante" required></v-text-field>
                    </div> 
                    <div class="col-xs-12 col-sm-6">
                        <v-text-field v-model.trim="fecha" type="date" step="0.01" :counter="10" label="fecha deposito" required></v-text-field>
                    </div> 
                    <div class="col-xs-12 col-sm-6">
                        <v-file-input v-model="archivo" :counter="10" @change="onFileChange" accept="image/*" label="Imagen del comprobante" required></v-file-input>
                    </div> 
                </div>

                <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>

                <p class="text-center red--text"> {{ msg }} </p>

                <div class="text-center">
                  <v-btn :disabled="loading" tile color="success" class="mr-4" @click="registrar()" >
                    <v-icon left>mdi-package-variant</v-icon>
                    {{ item?'guardar cambios':'Abrir caja' }}
                  </v-btn>
                </div> 
            </v-form>
        </v-card-text> 
      </v-card>
  
        
      </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false,
      valor: '',
      comprobante: '',
      archivo:null,
      archivo64:null,
      fecha:null,
      msg: '',
      valorRules: [
        v => !!v || 'requerido',
        v => (v && v > 0) || 'positivo',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      item: null, 
      cuentas: [],
    }
  },

  computed:{
    getuser(){
      let n = this.$store.state.DATA_USER.nombres;
      let ap = this.$store.state.DATA_USER.pri_apellido;
      let am = this.$store.state.DATA_USER.seg_apellido;
      if(!am) am = '';
      return `${n} ${ap} ${am}`;
    },
    getfecha(){
      const fechaActual = new Date(); 
      const dia = fechaActual.getDate();
      const mes = fechaActual.getMonth() + 1;
      const año = fechaActual.getFullYear(); 
      const fechaFormateada = `${dia.toString().padStart(2, '0')}/${mes.toString().padStart(2, '0')}/${año}`;
      return fechaFormateada;
    },
    getsede(){
      let n = this.$store.state.CARGO.sede.nombre;
      return n;
    }
  },

  methods: {
    openmodal(item=null){
        this.dialog = true; 
        this.valor = '';
        this.item = item;
        this.archivo64 = null; 
        this.getData(item);
        this.getSede(1);
    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onFileChange(file) {
        let vue = this;
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          let b64 = reader.result;
          let inde = b64.indexOf(';base64,')+8;
          window.console.log(inde);
          vue.archivo64 = b64.substring(inde);
          // window.console.log(vue.archivo64);
        };
        reader.onerror = function (err) {
          window.console.log("Error:", err);
        };
      },
      async getData(cajaid){
        this.loading = true;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas/${cajaid}`
        const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
        window.console.log('>>> res',res);
        if(res && res.data){
            this.cajita = res.data;
        }
        this.loading = false;
    }, 
    async getSede(idsede){ 
      let sql = gql`query{ getSede(id:${idsede}){ cuentasBancarias{id,nombre,nro} } }`;
      let res = await this.$apollo.query({ query: sql }).then(r=>r).catch(e=>e);
      this.cuentas = res.data.getSede.cuentasBancarias;
      window.console.log( this.cuentas );
    },

      async registrar(){
        this.msg = ''; 
        if(!this.valor) this.msg = 'ingrese el monto';
        if(!this.comprobante) this.msg = 'ingrese el comprobante';
        if(!this.fecha) this.msg = 'ingrese la fecha';
        if(!this.archivo64) this.msg = 'seleccione el archivo';
        if(!this.item) this.msg = 'error, no hay id de la caja, pruebe salir y volver a intentar';
        if(this.msg) return;
        this.loading = true;

        /* 
        type DepositoCaja struct {
          ID               *uint64          `json:"id"`
          CuentaBancariaID *uint64          `json:"cuenta_bancaria_id"`
          MontoDepositado  decimal.Decimal  `json:"monto_depositado"`
          FechaDeposito    *string          `json:"fecha_deposito"`
          Comprobante      *string          `json:"comprobante"`
          ArchivoBase64    *string          `json:"archivo_recibo"`
        }
        */

        let input = {
          id: parseInt(this.item),
          monto_depositado: this.valor,
          fecha_deposito: this.fecha,
          comprobante: this.comprobante,
          archivo_recibo: this.archivo64
        }

        window.console.log(input);

        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/depositocajas`; 
        const res = await xaxios.put(url,input).then(x=>x).catch(x=>x);
        window.console.log('res:', res);
        if(res && res.response){
          let xms = res.response.data.data;
          this.msg = xms;
        }else if(res && res.data){
          this.$root.$notify.show(`Comrobante agregado`, {color:'#03931D',x: 'right',y:'top'});
          this.dialog = false;
          this.$emit('success');
        }
        
        this.loading = false;
      },

      msgErr(res){ 
        try{ this.msg = res.response.data.data; }
        catch(e){ this.msg = res }
        
      }
    },
}
</script>